module.exports = __webpack_public_path__ + "img/58-r.d88aafac.png";